module.exports = __webpack_public_path__ + "fonts/Roboto-Light.ttf?01744b0f7878c20cdcbd7b3a18040d33";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Light.ttf
// module id = 311
// module chunks = 0